import { render, staticRenderFns } from "./NewsPoster.vue?vue&type=template&id=193eb264&"
import script from "./NewsPoster.vue?vue&type=script&lang=js&"
export * from "./NewsPoster.vue?vue&type=script&lang=js&"
import style0 from "./NewsPoster.vue?vue&type=style&index=0&id=193eb264&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports